module.exports = __webpack_public_path__ + "img/right_chevron.28adf5c0.svg";